import React, { useContext } from "react";
import styled from "@emotion/styled";

import Context from "./MediaCentreContext";

// style rules
import { Sizes, Colors } from "../../styles";

import MediaItemCard from "./MediaItemCard";
import NoResults from "../NoResults";
import Pagination from "../pagination/Pagination";

const MediaItemsList = () => {
	const {
		data: { mediaItems, totalPages, currentPageNumber },
		actions: {
			handleButtonPageSelect,
			handleDecrementPage,
			handleIncrementPage,
		},
	} = useContext(Context);

	const renderMediaItemCard = () => {
		if (mediaItems.length === 0) {
			return <NoResults text={"No media items found"} color={Colors.base.black} />;
		}
		return mediaItems.map((item) => {
			return <MediaItemCard key={item.slug} mediaItem={item} />;
		});
	};

	return (
		<Container aria-label="American rivers media items section">
			<List>{renderMediaItemCard()}</List>
			{totalPages && totalPages.length > 0 && (
				<Pagination
					handleDecrementPage={handleDecrementPage}
					handleIncrementPage={handleIncrementPage}
					totalPages={totalPages}
					handleButtonPageSelect={handleButtonPageSelect}
					currentPageNumber={currentPageNumber}
				/>
			)}
		</Container>
	);
};

export default MediaItemsList;

const Container = styled.div`
	padding: 6rem 0 8rem 0;
	max-width: ${Sizes.grids.insetWidthMedium};
	margin: 0 auto;
`;

const List = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 4rem;
	margin: 0;
	padding: 0;
	max-width: unset;
`;
